import {
  MENU_ITEMS_ADMINISTRATION,
  MENU_ITEMS_CUSTOMER,
  MENU_ITEMS_SUPPLIER,
} from "../constants/menu";
import { useSelector } from "react-redux";

const GetMenuItems = (user) => {
  /*   const { user } = useSelector((state) => ({
    user: state.Auth.user,
  })); */
  if (user.type === "customer" || user.type === "demoCustomer") {
    return MENU_ITEMS_CUSTOMER;
  }
  if (user.type === "supplier") {
    return MENU_ITEMS_SUPPLIER;
  }
  if (user.type === "administration") {
    return MENU_ITEMS_ADMINISTRATION;
  }
  // NOTE - You can fetch from server and return here as well
};

const findAllParent = (menuItems, menuItem) => {
  let parents = [];
  const parent = findMenuItem(menuItems, menuItem["parentKey"]);

  if (parent) {
    parents.push(parent["key"]);
    if (parent["parentKey"])
      parents = [...parents, ...findAllParent(menuItems, parent)];
  }
  return parents;
};

const findMenuItem = (menuItems, menuItemKey) => {
  if (menuItems && menuItemKey) {
    for (let i = 0; i < menuItems.length; i++) {
      if (menuItems[i].key === menuItemKey) {
        return menuItems[i];
      }
      let found = findMenuItem(menuItems[i].children, menuItemKey);
      if (found) return found;
    }
  }
  return null;
};

const MenuUrl = (item) => {
  const { user } = useSelector((state) => ({
    user: state.Auth.user,
  }));
  const userFilters = user?.settings?.defaultFilters?.[item.key] || null;

  const params = [];
  if (item.startPage) {
    params.push(`page=${item.startPage}`);
  }

  if (userFilters) {
    if (userFilters.sortBy) {
      params.push(`sortBy=${userFilters.sortBy}`);
    }
    if (userFilters.sortDirection) {
      params.push(`sortDirection=${userFilters.sortDirection}`);
    }
    if (userFilters.filters) {
      Object.keys(userFilters.filters).forEach((key) => {
        params.push(
          `${key}=${encodeURIComponent(
            encodeURIComponent(JSON.stringify(userFilters.filters[key]))
          )}`
        );
      });
    }
  } else {
    if (item.standardSortBy) {
      params.push(`sortBy=${item.standardSortBy}`);
    }
    if (item.standardSortDirection) {
      params.push(`sortDirection=${item.standardSortDirection}`);
    }
    if (item.standardFilters) {
      Object.keys(item.standardFilters).forEach((key) => {
        params.push(
          `${key}=${encodeURIComponent(
            encodeURIComponent(JSON.stringify(item.standardFilters[key]))
          )}`
        );
      });
    }
  }
  const url = `${item.url}${params.length ? `?${params.join("&")}` : ""}`;

  return url;
};

export { GetMenuItems, findAllParent, findMenuItem, MenuUrl };
